"use client";

import { Card, CardContent, CardHeader } from "@garagem/ui/components/card";
import { Skeleton } from "@garagem/ui/components/skeleton";

export function AuthPageSkeleton({
  showDescription = true,
}: {
  showDescription?: boolean;
}) {
  return (
    <Card>
      <CardHeader>
        <Skeleton className="h-7 w-36" />
        {showDescription && <Skeleton className="mt-2 h-4 w-64" />}
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-full" />
        </div>
        <Skeleton className="h-10 w-full" />
      </CardContent>
    </Card>
  );
} 